import { Navbar, NavbarToggler, Nav, NavLink, Button } from "reactstrap";
import styled from 'styled-components';

export const NavbarDiv = styled(Navbar)`
  background-color: ${({ theme }) => theme.colors.mainBrown};
  padding: 1rem 0 1rem 0;
`
export const MyNav = styled(Nav)`
  margin-left: auto;
  text-align: center;
`
export const NavLinkDiv = styled(NavLink)`
  color: ${({ theme }) => theme.colors.mainSilver};
  margin-right:1.2rem;
  :hover{
    color: ${({ theme }) => theme.colors.mainOrange};
  }
`
export const Btn = styled(Button)`
    background-color: ${({ theme }) => theme.colors.mainOrange};
    border-color: ${({ theme }) => theme.colors.mainOrange};
    letter-spacing: 1px;
    :hover{
        color: ${({theme}) => theme.colors.mainBrown};
        background-color: ${({theme}) => theme.colors.white};
    }
`
export const Img = styled.img`
    height: 3.2rem;
`
export const TogglerBtn = styled(NavbarToggler)`
    border: 1px solid white;
    svg {
        color: white;
    }
`